"use client";

import { useLingui } from "@lingui/react/macro";
import { radioCardStyles } from "@offstreetparking/design-system/forms";
import { ChevronRightIcon } from "@offstreetparking/design-system/icons/ChevronRightIcon";
import { Heading, Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
type TenantStepProps = {
	tenants: Array<{
		id: number;
		name: string;
	}>;
	onSelect: (tenantId: number) => void;
};
export const TenantStep = ({ tenants, onSelect }: TenantStepProps) => {
	const { t } = useLingui();
	return (
		<div className="space-y-4 p-8">
			<Heading>{t`Select Tenant`}</Heading>
			<ul className="flex flex-col gap-2">
				{tenants.map((tenant) => (
					<li key={tenant.id}>
						<button
							type="button"
							aria-label={`${t`Select Tenant`}: ${tenant.name}`}
							onClick={() => onSelect(tenant.id)}
							className={classNames(
								radioCardStyles({
									checked: false,
								}),
								"flex w-full cursor-pointer flex-row items-center px-4 py-3 hover:border-primary",
							)}
						>
							<div className="flex flex-1 flex-col gap-1 text-left">
								<Text As="span" weight="bold">
									{tenant.name}
								</Text>
							</div>
							<ChevronRightIcon className="h-6 w-6 text-primary" aria-hidden="true" />
						</button>
					</li>
				))}
			</ul>
		</div>
	);
};
